import React, { useState } from 'react'
import { Table, Tooltip, Spin, Checkbox, Upload, message, Popconfirm, Button, Space, Modal } from "antd";
import { formatIndianDate, uploadAgreementType } from '../../../utils/Constant';
import { capitalizeAndRemoveUnderscores, limitWords } from '../../../utils/utils';
import { FolderAddOutlined, CheckCircleOutlined, FileDoneOutlined, CloseCircleOutlined, FileExcelOutlined, FileZipOutlined, InboxOutlined, DeliveredProcedureOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { editBulkAgreementAction, deleteBulkAgreementAction } from "../../../app/slice/bulkUploadSlice";
import HoverIcon from '../../../components/icons/HoverIcon';
import axiosInstance from '../../../utils/axiosInstance';


export default function XlUploadedTable() {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0); // Track current object
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [dupData, setDupData] = useState([]); // Store API response data
    const dispatch = useDispatch();
    const bulkUploadData = useSelector((state) => state.bulkUploadData.data);
    const [loadInfo, setLoadInfo] = useState({
        isLoading: false,
        type: '',
        id: ''
    })

    const onDeleteRow = (type, index, id) => {
        if (type === 'all' || bulkUploadData.length == 1) {
            onClearTable()
            return;
        } else if (!!id) {
            if (!selectedRowKeys.includes(id)) {
                message.error('Kindly ensure the data is checked before proceeding.');
                return false;
            }
            dispatch(deleteBulkAgreementAction(id));
            setSelectedRowKeys(val => val.filter(uid => uid != id))
        }
    }

    const onUploadAggrement = (index, file) => {
        if (!file) return;

        // Convert File to Base64 (Alternative: Convert to Blob)
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
            const blob = new Blob([reader.result], { type: file.type })
            // dispatch(editBulkAgreementAction({id:bulkUploadData[index].uid, key: "file", value: blob }))
            dispatch(
                editBulkAgreementAction({
                    id: bulkUploadData[index].uid, key: "file", value: {
                        name: file.name,
                        type: file.type,
                        blob: blob, // Store Blob in Redux
                    }
                })
            );
        }

        return false;
    }

    const onDeleteAggrement = (index) => {
        dispatch(editBulkAgreementAction({ id: bulkUploadData[index].uid, key: "file", value: '' }));
    }

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all rows
            const allRowKeys = bulkUploadData?.map((item) => item.uid);
            setSelectedRowKeys(allRowKeys);
        } else {
            // Deselect all rows
            setSelectedRowKeys([]);
        }
    };

    const onSubmit = async (index) => {
        // contract/create-bulk-agreements/
        try {
            const agrData = { ...bulkUploadData[index] };
            if (!selectedRowKeys.includes(agrData.uid)) {
                message.error('Your Aggrement is Uncheck .');
                return;
            }
            if (!agrData.file) {
                message.error('Please upload agreement file .');
                return;
            }
            setLoadInfo({
                isLoading: true,
                type: 'submit',
                id: agrData.uid
            })
            // Convert Blob to File
            const fileObj = new File([agrData.file.blob], agrData.file.name, { type: agrData.file.type });

            const formData = new FormData();

            formData.append('agreement_file_' + agrData.uid, fileObj);
            formData.append('agreements', JSON.stringify([agrData]));
            const response = await axiosInstance.post(`/contract/create-bulk-agreements/`, formData);
            if (response.status == 200) {
                setDupData(response.data.existing_agreements)
                message.success(response.data.message);
                setSelectedRowKeys(val => val.filter(uid => uid != bulkUploadData[index].uid))
                if (response.data.existing_agreements.length > 0) {
                    setIsModalVisible(true);
                } else {
                    dispatch(deleteBulkAgreementAction(bulkUploadData[index].uid));
                }
            } else {
                console.log(response, 'response')
                //   message.error(data.message);
            }

        } catch (error) {
            console.error(error)
        } finally {
            setLoadInfo({
                isLoading: false,
                type: '',
                id: ''
            })
        }

    }

    // sent to archive
    const onArchive = async (agrData) => {
        try {
            setLoadInfo({
                isLoading: true,
                type: 'archive',
                id: agrData.uid
            })
            const formData = new FormData();
            formData.append('agreement_file_' + agrData.uid, '');
            if (agrData.file) {
                const fileObj = new File([agrData.file.blob], agrData.file.name, { type: agrData.file.type });
                formData.append('agreement_file_' + agrData.uid, fileObj);
            }
            formData.append('agreements', JSON.stringify([agrData]));
            const response = await axiosInstance.post(`/contract/archive-agreement/`, formData);
            if (response.status == 200) {
                message.success(response.data.message);
                dispatch(deleteBulkAgreementAction(agrData.uid));
            } else {
                console.log(response, 'response')
                //   message.error(data.message);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadInfo({
                isLoading: false,
                type: '',
                id: ''
            })
        }
    }

    const columns = [
        {
            title: (
                <Checkbox
                    indeterminate={
                        selectedRowKeys.length > 0 &&
                        selectedRowKeys.length < bulkUploadData.length
                    }
                    checked={selectedRowKeys.length === bulkUploadData.length}
                    onChange={handleSelectAllChange}
                />
            ),
            dataIndex: "checkbox",
            width: 60,
    ellipsis: true,
            render: (_, record) => (
                <Checkbox
                    checked={selectedRowKeys.includes(record.uid)}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedRowKeys([...selectedRowKeys, record.uid]);
                        } else {
                            setSelectedRowKeys(
                                selectedRowKeys.filter((key) => key !== record.uid)
                            );
                        }
                    }}
                />
            ),
        },
        {
            title: (
                <Tooltip className="whitespace-nowrap" title="Date of Raising (dd-mm-yyyy)">Date of Raising <br />
                    (dd-mm-yyyy)</Tooltip>
            ),
            dataIndex: "Execution date",
            key: "Execution date",
            width: 150,
            ellipsis: true,
            render: (date, record) => (
                <span style={{}}>
                    {formatIndianDate(date)}
                </span>
            ),
        },
        {
            title: "Agreement Type",
            dataIndex: "Agreement Type",
            width: 160,
            ellipsis: true,
            render: (text, record) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",

                        }}
                    >
                        {limitWords(text, 6)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Partner Name",
            dataIndex: "Business Entity Name",
            width: 140,
            ellipsis: true,
            render: (text, record) => (
                <span >
                    {text && text.charAt(0).toUpperCase() + text.slice(1)}
                </span>
            ),
        },
        {
            title: "Nature",
            dataIndex: "Nature",
            width: 100,
            ellipsis: true,
            render: (text, record) => (
                <span style={{}}>
                    {text && text.charAt(0).toUpperCase() + text.slice(1)}
                </span>
            ),
        },
        {
            title: "Status",
            dataIndex: "Status",
            width: 100,
            ellipsis: true,
            render: (text, record) => (
                <span style={{}}>
                    {capitalizeAndRemoveUnderscores(text)}
                </span>
            ),
        },
        // {
        //     title: <Tooltip className="whitespace-nowrap" title="Remarks(if any)">
        //         <span>Remarks(if any)</span>
        //     </Tooltip>,
        //     dataIndex: "Remarks",
        //     width: 140,
        //     ellipsis: true, // Enable ellipsis for the column
        //     render: (text, record) => (
        //         <Tooltip title={text}>
        //             <div
        //                 style={{
        //                     overflow: "hidden",
        //                     textOverflow: "ellipsis",
        //                     whiteSpace: "nowrap",

        //                 }}
        //             >
        //                 {limitWords(text, 6)}
        //             </div>
        //         </Tooltip>
        //     ),
        // },
        {
            title: "Upload File",
            key: "upload",
            width: 140,
            ellipsis: true,
            render: (_, record, index) => (
                <Space>
                    <Upload
                        beforeUpload={(file) => onUploadAggrement(index, file)}
                        showUploadList={true}
                        accept={uploadAgreementType}
                    >
                        <Button
                            type={record.file ? "primary" : "default"}  // Makes it stand out
                            style={record.file ? { color: "green", borderColor: "green" } : {}}
                            icon={
                                loadInfo.type == 'addFile' && loadInfo.id == record.uid ? (
                                    <Spin size="small" />
                                ) : record.file ? (
                                    <FileDoneOutlined style={{ fontSize: "24px" }} />
                                ) : (
                                    <FolderAddOutlined style={{ fontSize: "24px" }} />
                                )
                            }
                            disabled={record.file || loadInfo.isLoading} >
                        </Button>
                    </Upload>

                    {record.file && <Tooltip title={record.file.name}> <span style={{ marginLeft: 8 }}>{limitWords(record.file.name)}</span> </Tooltip>}
                </Space>
            ),
        },
        {
            title: "Actions",
            key: "actions",
            width: 140,
            ellipsis: true,
            render: (_, record, index) => (
                <Space>
                    {/* Delete File Button */}
                    <Popconfirm
                        title="Are you sure to delete this file?"
                        onConfirm={() => onDeleteAggrement(index)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <HoverIcon
                            icon={<FileExcelOutlined />}
                            tooltip="Delete Uploaded File"
                            color={!record.file ? "gray" : "red"}
                            hoverBgColor={!record.file ? "transparent" : "#ffccc7"}
                            onClick={() => { }}
                            hoverColor={!record.file ? "gray" : "red"}
                            disabled={!record.file || loadInfo.isLoading}
                            isLoading={loadInfo.type == 'deleteFile' && loadInfo.id == record.uid}
                        />

                    </Popconfirm>

                    {/* Delete Row Button */}
                    <Popconfirm
                        title="Are you sure to delete this row?"
                        onConfirm={() => onDeleteRow("single", index, record.uid)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <HoverIcon
                            icon={<CloseCircleOutlined />}
                            tooltip="Delete This Row"
                            color="red"
                            hoverBgColor="#ffccc7"
                            disabled={loadInfo.isLoading}
                            isLoading={loadInfo.type == 'deleteRow' && loadInfo.id == record.uid}
                            onClick={() => { }}
                            hoverColor="darkred"
                        />
                    </Popconfirm>

                    {/* Submit Agreement Button */}
                    <HoverIcon
                        icon={<CheckCircleOutlined />}
                        tooltip="Submit This Agreement"
                        color="green"
                        hoverBgColor="#d9f7be"
                        disabled={loadInfo.isLoading}
                        isLoading={loadInfo.type == 'submit' && loadInfo.id == record.uid}
                        onClick={() => onSubmit(index)}
                        hoverColor={"darkgreen"}
                    />

                    <HoverIcon
                        icon={<InboxOutlined />}
                        tooltip="Archive This Agreement"
                        color={"rgb(163, 149, 218)"} // Blue for unarchive, yellow for archive
                        hoverColor="white"
                        hoverBgColor={"rgb(163, 149, 218)"} // Dynamic hover effect
                        onClick={() => onArchive(record)}
                        disabled={loadInfo.isLoading}
                        isLoading={loadInfo.type == 'archive' && loadInfo.id == record.uid}
                    />
                </Space>
            ),
        }


    ];

    const onClearTable = () => {
        const selectedUid = [];
        bulkUploadData.forEach((item) => {
            if (selectedRowKeys.includes(item.uid)) {
                dispatch(deleteBulkAgreementAction(item.uid));
                selectedUid.push(item.uid)
            }
        })
        if (!selectedUid.length) {
            message.error('Kindly ensure the data is checked before proceeding.');
            return;
        }
        setSelectedRowKeys(val => val.filter(uid => !selectedUid.includes(uid)));
        message.success("Selected data are deleted.");
    };

    const onSubmitAll = async () => {

        try {
            const formData = new FormData();
            const data = bulkUploadData.filter((item) => {
                if (selectedRowKeys.includes(item.uid) && !!item.file) {
                    const fileObj = new File([item.file.blob], item.file.name, { type: item.file.type });
                    formData.append('agreement_file_' + item.uid, fileObj);

                    return true;
                }
            });
            formData.append('agreements', JSON.stringify(data));

            if (!data.length) {
                message.error('Please ensure at least one agreement is checked and uploaded . ')
                return;
            }
            setLoadInfo({
                isLoading: true,
                type: 'allSubmit',
                id: ''
            })
            const response = await axiosInstance.post(`/contract/create-bulk-agreements/`, formData);
            if (response.status == 200) {
                setDupData(response.data.existing_agreements);
                message.success(response.data.message);

                if (!!response.data.new_agreements.length) {
                    response.data.new_agreements.forEach((item) => {
                        dispatch(deleteBulkAgreementAction(item.uid));
                    })
                    setSelectedRowKeys(val => val.filter((id) => response.data.new_agreements.some((sucAgr) => sucAgr.uid != id)))
                }

                if (response.data.existing_agreements.length > 0) {
                    setIsModalVisible(true);
                }

            } else {
                console.log(response, 'response')
                //   message.error(data.message);
            }
        } catch (error) {
            console.error(error)

        } finally {
            setLoadInfo({
                isLoading: false,
                type: '',
                id: ''
            })
        }

    }


    // Handle "No" button click -> Show next modal

    const handleAddNo = () => {
        setIsModalVisible(false);
        setIsDeleteModalVisible(true);
    };

    // Handle "Yes" button click -> Call API and then show next modal
    const forcefullyAdd = async () => {
        setLoading(true);
        try {
            const uid = dupData[currentIndex]['uid'];
            delete dupData[currentIndex]['uid'];
            const payload = { existing_agreements: [dupData[currentIndex]] };
            setLoadInfo({
                isLoading: true,
                type: 'forceAdd',
                id: uid
            })
            const response = await axiosInstance.post(`/contract/force-create-agreements/`, payload);
            if (response.status == 200) {
                message.success(response.data.message);
                dispatch(deleteBulkAgreementAction(uid));
                setSelectedRowKeys(val => val.filter((id) => id != uid))
                nextObject();
            } else {
                message.error("Failed to process");
            }

        } catch (error) {
            message.error(error, "API error");
        } finally {
            setLoadInfo({
                isLoading: false,
                type: '',
                id: ''
            })
            setLoading(false);
        }
    };

    // Handle "Yes" button click -> Call API and then show next modal
    const handleAddYes = async () => {
        await forcefullyAdd();
        nextObject();
    };

    // Move to the next object or close modal

    const nextObject = () => {
        if (currentIndex + 1 < dupData.length) {
            setCurrentIndex(currentIndex + 1);
            setIsDeleteModalVisible(false);
            setIsModalVisible(true);
        } else {
            setIsModalVisible(false);
            setIsDeleteModalVisible(false);
            setCurrentIndex(0);
            setDupData([]);

        }
    };

    // Handle "Delete Yes" button click -> Call API and then show next modal
    const handleDeleteYes = () => {
        const rowId = dupData[currentIndex].uid;
        onDeleteRow('single', null, rowId)
        nextObject();
    };

    // Handle "Delete No" button click -> Show next object
    const handleDeleteNo = () => {
        nextObject();
    };

    return (
        <div className='my-2' style={{ marginTop: '16px' }}>
            {!!bulkUploadData.length && <Space className='my-2' style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
                <Tooltip title="Approve and Submit Checked Data">
                    <Button
                        disabled={loadInfo.isLoading}
                        loading={loadInfo.type === 'allSubmit'}
                        type="primary" onClick={onSubmitAll}>
                        Submit Data
                    </Button>
                </Tooltip>
                <Button disabled={loadInfo.isLoading} type="primary" onClick={() => { onDeleteRow('all') }}>
                    Delete All Data
                </Button>
            </Space>}
            <div className=" border border-gray-300" style={{ overflowX: 'auto' }}>
                <Table
                    columns={columns}
                    dataSource={bulkUploadData}
                    scroll={{ x: "max-content", y: 400 }}
                    pagination={false}
                    className='text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]'
                />
            </div>

            <Modal
                title="Duplicate Agreement"
                open={isModalVisible} // Use 'open' instead of 'visible'
                onCancel={() => setIsModalVisible(false)}
                footer={[
                    <Button key="no" onClick={handleAddNo} disabled={loading}>
                        No
                    </Button>,
                    <Button key="yes" type="primary" onClick={handleAddYes} loading={loading}>
                        Yes
                    </Button>,
                ]}
            >
                {dupData.length > 0 && (
                    <p>{`The details of ( ${dupData[currentIndex]?.party}_ ${dupData[currentIndex]?.nature} ) are identical to the other Agreement with Agreement ID  ${dupData[currentIndex]?.document_id}. Would you still like to proceed?`}</p>
                )}
            </Modal>
            <Modal
                title="Delete Confirmation"
                open={isDeleteModalVisible} // Use 'open' instead of 'visible'
                onCancel={() => setIsDeleteModalVisible(false)}
                footer={[
                    <Button key="no" onClick={handleDeleteNo} disabled={loading}>
                        No
                    </Button>,
                    <Button key="yes" type="primary" danger onClick={handleDeleteYes} loading={loading}>
                        Yes, Delete
                    </Button>,
                ]}
            >
                <p>Do you want to delete this? </p>
            </Modal>


        </div>
    )
}
